import React, {useEffect} from 'react';
import auth from '../../lib/auth';


export default function AuthReceiverPage() {

    useEffect(() => {
        const listener = (m: MessageEvent) => {
            // SECURITY: Strict origin validation - prevent origin bypass attacks
            const expectedOrigin = window.location.protocol + '//' + process.env.REACT_APP_TI_DOMAIN;
            if (m.origin === expectedOrigin) {
                const token = m.data;
                // SECURITY: Validate token is non-empty before setting
                if (token && typeof token === 'string' && token.trim() !== '') {
                    auth.setToken(token);
                } else {
                    console.error('[auth-receiver] Invalid or empty token received');
                }
            }
        };
        window.addEventListener('message', listener);

        return function cleanup() {
            window.removeEventListener('message', listener);
        };
    }, []);

    return <div />;
}